<template>
    <modal
      :name="$lang.messages.nlp_title"
      :adaptive="true"
      height="auto"
      :width="500"
      transition="linear"
      :delay="0.15"
      @opened="setFocus"
    >
      <modals-header
        :modalNameProp="$lang.messages.nlp_title"
        @hideModalProp="hideConfirmModal"
      >
      </modals-header>
  
      <hr class="v--modal-hr">
      
      <div class="fp-modal">
        <div>
          {{$lang.messages.nlp_body}} ?
        </div>
        <button
          type="button"
          class="generic-btn"
          @click="hideConfirmModal"
        >
          {{ $lang.messages.cancel }}
        </button>
        <button
          type="button"
          class="action-btn"
          @click="sendMessage()"
          ref="sendMessageButton"
        >
          <span>
            {{$lang.messages.nlp_confirm}}
          </span>
        </button>
      </div>
    </modal>
</template>

<script>
  import modalsHeader from "@/components/common/modals/ModalsHeader";
  
  export default {
    name: "NLPConfirmModal",
    components: {
      'modals-header': modalsHeader
    },
    data() {
      return {
        message: '',
        guid: '',
        showModal: false
      };
    },
    destroyed() {
        this.showModal = false;
    },
    methods: {
      show(message) {
        this.message = message;
        this.showModal = true;
        this.$modal.show(this.$lang.messages.nlp_title);
      },
      hideConfirmModal() {
        this.showModal = false;
        this.$modal.hide(this.$lang.messages.nlp_title)
      },
      sendMessage() {
        this.$emit("confirmMessage", true);
        this.hideConfirmModal()
      },
      setFocus() {
        this.$refs.sendMessageButton.focus()
      },
    }
  }
</script>
